import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { migrateFontBoldStyleToFontWeightMutably } from '../../../services/compat/migration.helpers';
import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const signatureV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate signature element to v2',
  run: (props: PartialPropsOf<'signature'>): void => {
    migrateFontBoldStyleToFontWeightMutably(props?.style?.inputFont);
  },
};
